export default __webpack_public_path__ + "static/media/ark.6a4adbc1.png";